import React from 'react';
import { useHistory } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AccessTimeFilledRounded as InfoRoundedIcon } from '@mui/icons-material';
import IconVerifySuccess from '@src/assets/icons/ic-verify-success.svg';
import DialogWithContent from '@src/components/DialogWithContent';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import routes from '@src/constants/route';
import {
  StyledRequestDialogContent,
  StyledRequestDialogNote,
  StyledRequestDialogAction,
} from './index.style';

const RequestDialogSuccess = ({ open, onClose, onViewHistory }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClose = async () => {
    onClose();
  };

  const handleViewWithdrawalHistory = () => {
    if (onViewHistory) onViewHistory();
    else history.push(routes.TRANSACTIONS_HISTORY);
    onClose();
  };

  const renderContent = () => (
    <StyledRequestDialogContent>
      <StyledRequestDialogNote>
        <InfoRoundedIcon className="note-icon" />
        <Typography className="note-text">
          {t('requestWithdrawalSuccessDescription')}
        </Typography>
      </StyledRequestDialogNote>
    </StyledRequestDialogContent>
  );

  const renderAction = () => (
    <StyledRequestDialogAction>
      <CommonButton
        onClick={handleViewWithdrawalHistory}
        variant="outlined"
        className="dialog-actions-button"
        sx={{
          height: '40px',
          border: `1px solid ${COLOR.secondary[16]}`,
          padding: '8px 16px',
          borderRadius: '8px',
        }}
        textProps={{
          variantText: 'body-14-medium',
          color: COLOR.indigo.default,
        }}
      >
        {t('viewWithdrawalHistory')}
      </CommonButton>
      <CommonButton
        onClick={handleClose}
        variant="contained"
        className="dialog-actions-button"
        sx={{
          height: '40px',
          padding: '8px 16px',
          borderRadius: '8px',
        }}
        textProps={{
          variantText: 'body-14-medium',
          color: COLOR.indigo.default,
        }}
      >
        {t('gotIt')}
      </CommonButton>
    </StyledRequestDialogAction>
  );

  return (
    <DialogWithContent
      image={IconVerifySuccess}
      title={t('requestWithdrawalSuccess')}
      actionComponent={renderAction()}
      open={open}
      onClose={onClose}
      contentPopup={renderContent()}
    />
  );
};

export default RequestDialogSuccess;
